const columnTypes = {
	expand: 'expand',
	html: 'html',
	icon: 'icon',
	iconText: 'iconText',
	iconDocumentContainerDialog: 'iconDocumentContainerDialog',
	avatar: 'avatar',
	link: 'link',
	text: 'text',
	badge: 'badge',
	consumptionValue: 'consumptionValue',
	currency: 'currency',
	tosAndPolicy: 'tosAndPolicy',
	readMore: 'readMore',
	selectRow: 'selectRow',
} as const

type ColumnType = keyof typeof columnTypes

export { columnTypes as default, type ColumnType }
